import React from 'react'
import Radio from '@components/Radio/Radio'
import { DougsLogo } from '@assets/svg'
import Button from '@components/Button'

interface RadioCardProps {
  selected: boolean
  onClick?: React.DOMAttributes<HTMLButtonElement>['onClick']
  children: React.ReactNode
}

interface Props {
  selected: boolean
  setSelected: (value: boolean) => void
  singleButton?: boolean
}

const RadioCard = ({ selected, onClick, children }: RadioCardProps) => {
  const color = selected ? 'black' : 'border-verylight-gray'

  return (
    <div className={`md:basis-1/2 flex text-center py-6 px-12 rounded-lg border-1 border-${color} mb-3 cursor-pointer relative`} onClick={onClick}>
      <div className="absolute top-3 right-3">
        <Radio selected={selected} />
      </div>
      {children}
    </div>
  )
}

const DougsForm = ({ selected, setSelected, singleButton }: Props) => {
  return (
    <div className="">
      <DougsLogo className="mx-auto mb-3" />
      <h2 className="[&&]:text-base [&&]:text-center [&&]:p-0 mb-4">Dougs, l'expert-comptable qui simplifie la vie des entrepreneurs</h2>
      <div className="bg-new-verylight-gray border-verylight-gray border-1 rounded-lg flex pl-3 pr-4 py-4 mb-8">
        <div className="h-5 w-5 mr-2 shrink-0 text-sm items-baseline">💡</div>
        <div className="text-sm text-left items-baseline italic">Chez Ma Domiciliation.fr, on accompagne chaque jour des entrepreneurs comme vous. C’est pourquoi on recommande vivement Dougs, l’expert-comptable en ligne le mieux noté par ses utilisateurs !</div>
      </div>
      <ul className="text-left text-sm mb-8 ml-[30px] [&&]:list-[circle]">
        <li>Offre spéciale : 2 mois offerts sans engagement !</li>
        <li>37 000 entrepreneurs satisfaits</li>
        <li>Cabinet en ligne inscrit à l'Ordre des experts-comptables</li>
        <li>Conseils comptables, juridiques et fiscaux en illimité par téléphone, mail ou tchat</li>
        <li>À partir de 79€ HT/mois</li>
      </ul>
      {singleButton ? 
        (
          <div className="flex flex-col md:flex-row gap-3">
            <Button
              onClick={() => setSelected(true)}
              className='max-w-[300px] mx-auto'
            >
              Je souhaite être contacté
            </Button>
          </div>
        ) : (
        <div className="flex flex-col md:flex-row gap-3">
          <RadioCard
            selected={selected}
            onClick={() => setSelected(true)}
          >
            <div className="text-center">
              <div className="text-sm">Oui je souhaite en savoir plus sur Dougs</div>
            </div>
          </RadioCard>
          <RadioCard
            selected={!selected}
            onClick={() => setSelected(false)}
          >
            <div className="text-center mx-auto">
              <div className="text-sm">Non, je suis satisfait de mon comptable</div>
            </div>
          </RadioCard>
        </div>
      )}
    </div>
  )
}

export default DougsForm